import "./post.css";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useState, useEffect, useContext, useRef } from "react";
import { Fade } from "react-awesome-reveal";
import axios from "axios";
import { format } from "timeago.js";
import { AuthContext } from "../../context/AuthContext";

export default function Post({ post }) {
  const [like, setLike] = useState(post.likes.length);
  const [isLiked, setIsLiked] = useState(false);
  const [comments, setComments] = useState([]);
  const [isCommentsOpen, setIsCommentsOpen] = useState(false);
  const [showComments, setShowComments] = useState(false);
  const [user, setUser] = useState({});
  const { user: currentUser } = useContext(AuthContext);
  const text = useRef()
  const PF = process.env.REACT_APP_PUBLIC_FOLDER;

  useEffect(() => {
    setIsLiked(post.likes.includes(currentUser._id));
  }, [currentUser._id, post.likes]);

  useEffect(() => {
    const fetchUser = async () => {
      const res = await axios.get(`https://conexus-api.vercel.app/api/users?userId=${post.userId}`);
      setUser(res.data);
    };
    fetchUser();
  }, [post.userId]);

  const newComment = async () => {
    try {
      await axios.put("https://conexus-api.vercel.app/api/posts/comment/" + post._id, { userId: currentUser._id, text: text.current.value })
    } catch (err) {
      console.log("Couldn't send comment to this post")
    }
  }

  const likeHandler = async () => {
    try {
      axios.put("https://conexus-api.vercel.app/api/posts/" + post._id + "/like", { userId: currentUser._id });
    } catch (err) {}
    setLike(isLiked ? like - 1 : like + 1);
    setIsLiked(!isLiked);
  };

  const toggleComments = async () => {
    try {
      setShowComments(x => !x);
      if (isCommentsOpen === false) {
        const res = await axios.get("https://conexus-api.vercel.app/api/posts/load/comments/" + post._id);
        setIsCommentsOpen(true);
        setComments(res.data);
      }
    } catch (err) {
      console.log("Couldn't load comments:");
      console.log(err)
    }
  }

  return (
    <Fade triggerOnce={true} >
      <div className="post">
        <div className="postWrapper">
          <div className="postTop">
            <div className="postTopLeft">
                <img
                  className="postProfileImg"
                  src={
                    user.profilePicture
                      ? PF + "person/" + user.profilePicture
                      : PF + "person/no-avatar.png"
                  }
                  alt=""
                />
              <span className="postUsername">{user.username}</span>
              <span className="postDate">{format(post.createdAt)}</span>
            </div>
            <div className="postTopRight">
              <MoreVertIcon />
            </div>
          </div>
          <div className="postCenter">
            <span className="postText">{post?.desc}</span>
            {(post.img) && <img
              className="postImg"
              src={post.img}
              alt=""
            />}
            <div className="postTags">
              {post.tags.map((tag, idx) => (
                <div className="postTag" key={idx}>
                  <span>{tag}</span>
                </div>
              ))}
            </div>
          </div>
          <div className="postBottom">
            <div className="postBottomLeft">
              <img
                className="likeIcon"
                src={isLiked
                  ? PF + "liked.png"
                  : PF + "like.png"
                }
                onClick={likeHandler}
                alt=""
              />
              <span className="postLikeCounter">{like}</span>
            </div>
            <div className="postBottomRight" onClick={toggleComments}>
              <span className={`postCommentText ${showComments && "showing"} unselectable`}>{post.comments.length} comments</span>
            </div>
          </div>
          {(showComments && comments) &&
            <div className="postComments">
              <div className="createComment">
                <img
                  className="commentProfileImg"
                  src={
                    currentUser.profilePicture
                      ? PF + "person/" + currentUser.profilePicture
                      : PF + "person/no-avatar.png"
                  } alt="" />
                <input
                  placeholder="Share your thoughts..."
                  type="text"
                  ref={text}
                  minLength="1"
                  maxLength="1000"
                />
                <button onClick={newComment}>
                Send 
                </button>
              </div>
              {comments.map((comment, idx) => (
                <div className="postComment" key={idx}>
                  <div className="commentTop">
                    <img
                      className="commentProfileImg"
                      src={
                        comment.profilePicture
                          ? PF + "person/" + comment.profilePicture
                          : PF + "person/no-avatar.png"
                      }
                      alt=""
                    />
                    <span className="commentUsername">{comment.username}</span>
                  </div>
                  <div className="commentBottom">
                    <span>{comment.text}</span>
                  </div>
                </div>
              ))}
            </div>
          }
        </div>
      </div>
    </Fade>
  );
}
